module.exports = __webpack_public_path__ + "static/assets/c5be71297df282279435e6659cad70fa.png";